const PAGE_TYPES = {
  GUIDED_PROJECT: 'guided-project',
  PROJECT: 'project',
  PORTFOLIO_PROJECT: 'portfolio-project',
} as const;

export default PAGE_TYPES;
